import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ultilities-menu',
  templateUrl: './ultilities-menu.component.html',
  styleUrls: ['./ultilities-menu.component.css']
})
export class UltilitiesMenuComponent implements OnInit {
  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Utilities')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/ultilities/ultilities-menu/ultilities-menu.component.ts